import React from "react";
import Banner from "../../components/LandingComponents/Banner";
import TopProperties from "../../components/LandingComponents/TopSellingProperties/TopSellingProperties";
import SpecialOffers from "../../components/LandingComponents/DiscountOffers/DiscountsOffer";
import HowItWorks from "components/companyLandingComponents/HowItWorks/HowItWorks";
import SisterConcerms from "pages/AboutUs/SisterConcerms";
import ProjectLocation from "components/companyLandingComponents/ProjectLocation/ProjectLocation";
import Amenities from "components/companyLandingComponents/Amenities/Amenities";
import IntroVideoSection from "components/companyLandingComponents/IntroVideo/IntroVideoSection";

const Landing = () => {
  return (
    <div>
      <div className="banner">
        <Banner />
      </div>
      <TopProperties />
      <SpecialOffers />
      <IntroVideoSection></IntroVideoSection>
      <HowItWorks></HowItWorks>
      <ProjectLocation></ProjectLocation>
      <Amenities></Amenities>
      <SisterConcerms></SisterConcerms>
    </div>
  );
};

export default Landing;
